export default __webpack_public_path__ + "maps-examples-annotation-views-thumbnail-960-cfcfffc72afb5573b9e754f3389bb835.png";